import { render, staticRenderFns } from "./sapAccount.vue?vue&type=template&id=16f2a936&scoped=true&"
import script from "./sapAccount.vue?vue&type=script&lang=js&"
export * from "./sapAccount.vue?vue&type=script&lang=js&"
import style0 from "./sapAccount.vue?vue&type=style&index=0&id=16f2a936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2a936",
  null
  
)

export default component.exports